<template>
  <validation-observer ref="providerObserver">
    <v-container fluid>
      <v-card outlined class="mt-3">
        <v-card-title>{{ $t('findInStore.settings.stock') }}</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6">
              <validation-provider
                rules="min_value:0|integer"
                :name="$t('findInStore.settings.limitedQuantityThreshold')"
                v-slot="{ errors }"
              >
                <v-text-field
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.limitedQuantityThreshold"
                  type="number"
                  :label="$t('findInStore.settings.limitedQuantityThreshold')"
                  required
                  :error-messages="errors"
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="6">
              <validation-provider
                :rules="`required|one_of:${availableIdentifierField.join(',')}`"
                :name="$t('findInStore.settings.identifierField')"
                v-slot="{ errors }"
              >
                <v-select
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.identifierField"
                  :label="$t('findInStore.settings.identifierField')"
                  :items="availableIdentifierField"
                  required
                  :error-messages="errors"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <validation-provider
                rules="min_value:0|integer"
                :name="$t('findInStore.settings.updateInterval')"
                v-slot="{ errors }"
              >
                <v-text-field
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.updateInterval"
                  type="number"
                  :label="$t('findInStore.settings.updateInterval')"
                  :error-messages="errors"
                  clearable
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </validation-observer>
</template>
<script>
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
  import { mapState } from 'vuex'

  extend('one_of', (value, values) => {
    return values.indexOf(value) !== -1
  })
  export default {
    name: 'FindInStoreSettingsStock',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    props: {
      settings: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState(['isOctipasAdmin']),
    },
    data() {
      return {
        availableIdentifierField: ['id', 'barcode', 'sku'],
      }
    },
    methods: {
      async hasErrors() {
        const valid = await this.$refs.providerObserver.validate()
        return !valid
      },
    },
  }
</script>
